import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';


const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function Outsourcing() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
      <Meta
         title="IT-аутсорсинг системного администрирования для бизнеса | IT Osoba"
         description="IT-аутсорсинг для бизнеса в Подольске и по России. Обслуживание компьютеров, серверов, 1С. Фиксированная стоимость, реакция за 15 минут, 24/7 поддержка. Получите расчет стоимости!"
       />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      {/* Заголовок */}
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#2c3e50',
        }}
      >
        IT-аутсорсинг для бизнеса: сэкономьте до 70% на штатном системном администраторе
      </h1>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Обслуживание по договору у нас — это выгодное решение, позволяющее значительно снизить расходы по сравнению с содержанием внутри организации нескольких специалистов для выполнения нерегулярных задач. Мы мотивированы оперативно и качественно решать любые вопросы, потому что конкуренция на рынке IT-услуг очень высока, и именно это побуждает нас работать максимально эффективно.
      </p>

      <h2 style={{ textAlign: 'center',
          marginBottom: '30px',
          color: '#2c3e50',
          
      }}
          >Почему выбирают нас:</h2>

<section>
    <h3 style={{
          marginBottom: '20px',
          color: '#2c3e50',}}>Ежедневная поддержка пользователей</h3>
  <ul style={{ fontSize: '1.2em', marginBottom: '20px' }}>
    <li>Удаленная настройка компьютеров и программ</li>
    <li>Решение проблем с офисной техникой (принтеры, сканеры, МФУ)</li>
    <li>Настройка почты, мессенджеров, корпоративных чатов</li>
    <li>Консультации сотрудников по IT-вопросам</li>
  </ul>
</section>

<section>
  <h3 style={{
          marginBottom: '20px',
          color: '#2c3e50',}}>Серверное и сетевое администрирование</h3>
  <ul style={{ fontSize: '1.2em', marginBottom: '20px' }}>
    <li>Администрирование серверов (даже если у вас "просто сетевое хранилище")</li>
    <li>Настройка и обслуживание Windows/Linux серверов</li>
    <li>Организация резервного копирования с проверкой восстановления</li>
    <li>Мониторинг нагрузки и предупреждение проблем</li>
    <li>Обновление операционных систем и серверного ПО</li>
  </ul>
</section>

<section>
  <h3 style={{
          marginBottom: '20px',
          color: '#2c3e50',}}>Сетевая инфраструктура</h3>
  <ul style={{ fontSize: '1.2em', marginBottom: '20px' }}>
    <li>Настройка Wi-Fi для офиса (чтобы не "падал" в переговорке)</li>
    <li>Организация VPN для удалённых сотрудников</li>
    <li>Настройка межсетевых экранов и правил доступа</li>
    <li>Контроль интернет-трафика и блокировка опасных ресурсов</li>
  </ul>
</section>

<section>
  <h3 style={{
          marginBottom: '20px',
          color: '#2c3e50',}}>Безопасность данных</h3>
  <ul style={{ fontSize: '1.2em', marginBottom: '20px' }}>
    <li>Защита от вирусов, шифровальщиков, фишинга</li>
    <li>Настройка политик паролей и прав доступа</li>
    <li>Шифрование конфиденциальных данных</li>
    <li>Обучение сотрудников основам безопасности</li>
  </ul>
</section>

<section>
  <h3 style={{
          marginBottom: '20px',
          color: '#2c3e50',}}>Специализированные системы</h3>
  <ul style={{ fontSize: '1.2em', marginBottom: '20px' }}>
    <li>Поддержка и обновление 1С (Бухгалтерия, УПП, ЗУП)</li>
    <li>Настройка CRM-систем (Битрикс24, amoCRM)</li>
    <li>Интеграция различных программных продуктов</li>
    <li>Миграция данных между системами и многое другое</li>
  </ul>
</section>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Преимущества сотрудничества:</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Мы предлагаем точечный подбор услуг, конфиденциальность, высокий уровень профессионализма и гибкую тарификацию, чтобы максимально соответствовать потребностям вашей организации.
      </p>
     <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>Узнайте, сколько вы переплачиваете за IT уже сейчас. <strong>Оставьте заявку или позвоните нам для бесплатного анализа вашей IT-инфраструктуры</strong> с точным расчетом экономии при переходе на аутсорсинг.</p>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        {/* <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button> */}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={e => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}